// extracted by mini-css-extract-plugin
module.exports = {"floatingToolbar":"style_floatingToolbar__uP5Rd"};